import React from 'react';
import FocusLock, { ReactFocusLockProps } from 'react-focus-lock';
import { Backdrop } from '#ui-kit/components/backdrop.view.js';
import { ModalPortal } from './modal.portal.view';
import { useOnEscape } from '../../utils/use-on-escape';

export const ModalWrapper = ({
  onClose,
  options = {},
  children,
  ...props
}: {
  onClose: Function;
  options?: ReactFocusLockProps;
  children: React.ReactNode;
  [key: string]: any;
}) => {
  useOnEscape(onClose);

  return (
    <ModalPortal>
      <FocusLock returnFocus {...options}>
        <Backdrop onClose={onClose} closeOnChildrenClick={false} {...props}>
          {children}
        </Backdrop>
      </FocusLock>
    </ModalPortal>
  );
};
